module.exports = __webpack_public_path__ + "static/media/Copy of ILEA STAFF (1)_1727962183019.18d03516.png";